import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "025af5b7-0768-4abf-a4cc-ba2fc5270a09",
  publicId: "10",
  name: "3D equations of acoustics",
  difficulty: 2,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, task01],
};

export default lesson;
